<template>
  <div>
    <div class="item-head">
      <span class="badge badge-pill badge-warning text-capitalize">{{ item.type }}</span>
      <span class="badge badge-pill badge-light">{{ item.id }}</span>
      <label class="mini-check"><input :id="`secure-${item.id}`" type="checkbox" v-model="item.security"> محافظت</label>
      <input type="text" class="form-control title-input" v-model="item.title" placeholder="عنوان">
      <b-icon class="bg-primary p-1 rounded-pill text-white" icon="plus" @click="addOption()"/>
      <b-icon class="bg-danger p-1 rounded-pill text-white" icon="trash" @click="deleteQuestion()"/>
    </div>
    <div class="opt-list">
      <div class="opt-row" v-for="(option,index) in item.options" :key="index">
        <span class="opt-n">{{ index + 1 }}</span>
        <input type="text" class="form-control form-control-sm" v-model="option.label">
        <input type="number" class="form-control form-control-sm opt-price" v-model="option.price" placeholder="قیمت" min="0">
        <b-icon class="text-danger" icon="x" @click="deletedOption(index)"/>
      </div>
    </div>
  </div>
</template>

<script>
import {generateHash} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/ShoppingCart";

export default {
  name: "SelectBoxInput",
  props: {item: {}},
  computed: {
    generateHashComputed() {
      return generateHash()
    }
  },
  methods: {
    addOption() {
      let countOptions = this.item.options.length
      this.item.options.push({
        "id": (countOptions + 1),
        "label": "ایتم",
        "value": 0,
        "price": ""
      })
      this.$forceUpdate()
    },
    deletedOption(index) {
      if (confirm('آیا از حذف ایتم اطمینان دارید؟')) {
        this.item.options.splice(index, 1)
        this.$forceUpdate()
      }
    },
    deleteQuestion() {
      this.$emit('removeQuestion')
    }
  },
}
</script>

<style scoped>
.item-head,
.opt-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
}
.item-head .form-control:not(.title-input) {
  flex: 1 1 160px;
}
.opt-row {
  margin-top: 4px;
}
.opt-row .form-control {
  flex: 1 1 160px;
}
.opt-n {
  font-size: 11px;
  color: #9ca3af;
  width: 16px;
}
.mini-check {
  font-size: 12px;
  margin: 0;
}
</style>
